import axios from 'lib/axios'

export const updateRequesterEmailApi = async (data) => {
  return await axios.patch(BoardMinutes.Constants.Routes.edit_requester_email, data)
}
